module.exports = __webpack_public_path__ + "img/specialService.b96c9a28.svg";